import { ArrowLeft, Clock3, Sparkles } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getStudentGrowthEvents } from '../../api.js'
import { useAuth } from '../../auth-context.js'
import { useLanguage } from '../../contexts/LanguageContext.jsx'

function eventTime(value, language) {
  if (!value) return '-'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '-'
  return date.toLocaleString(language === 'en' ? 'en-US' : 'zh-CN', { hour12: false })
}

function normalizeEvents(payload) {
  const events = Array.isArray(payload?.events) ? payload.events : []
  return events.map((event) => ({
    id: String(event.id || event.eventId || event.createdAt || event.created_at || event.title),
    title: event.title || '',
    description: event.description || '',
    type: event.eventType || event.event_type || event.type || '',
    createdAt: event.createdAt || event.created_at || event.updatedAt || event.updated_at || null,
  }))
}

function GrowthTimelinePage() {
  const { isLoggedIn } = useAuth()
  const { language, t } = useLanguage()
  const [state, setState] = useState({ loading: true, error: '', events: [] })

  useEffect(() => {
    if (!isLoggedIn) {
      setState({ loading: false, error: '', events: [] })
      return undefined
    }
    const controller = new AbortController()
    getStudentGrowthEvents(controller.signal)
      .then((payload) => setState({ loading: false, error: '', events: normalizeEvents(payload) }))
      .catch((error) => {
        if (error.name !== 'AbortError') {
          setState({ loading: false, error: error?.message || t('growthDaily.timelineLoadFailed'), events: [] })
        }
      })
    return () => controller.abort()
  }, [isLoggedIn, t])

  if (!isLoggedIn) {
    return (
      <main className="page-container student-growth-center-page">
        <section className="student-growth-daily-assistant">
          <div>
            <span><Clock3 size={18} /> {t('growthDaily.timeline')}</span>
            <h1>{t('growthDaily.timelineLoginTitle')}</h1>
            <p>{t('growthDaily.timelineLoginDesc')}</p>
          </div>
          <Link className="primary-button" to="/login">{t('common.login')}</Link>
        </section>
      </main>
    )
  }

  return (
    <main className="page-container student-growth-center-page">
      <section className="student-growth-daily-assistant">
        <div>
          <span><Clock3 size={18} /> {t('growthDaily.timeline')}</span>
          <h1>{t('growthDaily.timelineTitle')}</h1>
          <p>{t('growthDaily.timelinePageDesc')}</p>
        </div>
        <Link className="secondary-button" to="/growth"><ArrowLeft size={16} /> {t('growthDaily.backToGrowth')}</Link>
      </section>

      {state.loading ? <p className="student-growth-error is-success"><Sparkles size={16} /> {t('growthDaily.loading')}</p> : null}
      {state.error ? <p className="student-growth-error">{state.error}</p> : null}

      <section className="student-growth-timeline">
        <div className="student-growth-timeline-list">
          {state.events.length ? state.events.map((event) => (
            <article key={event.id}>
              <span>{eventTime(event.createdAt, language)}</span>
              <strong>{event.title || t('growthDaily.eventFallback')}</strong>
              <p>{event.description || t('growthDaily.eventFallbackDesc')}</p>
            </article>
          )) : (
            <article>
              <span>{t('growthDaily.waitingFirstRecord')}</span>
              <strong>{t('growthDaily.firstRecordTitle')}</strong>
              <p>{t('growthDaily.firstRecordDesc')}</p>
            </article>
          )}
        </div>
      </section>
    </main>
  )
}

export default GrowthTimelinePage
